import type { BuildingId } from '@/interfaces/Building.interface';
import { CoreApiVersionPath, RosaCoreApiService } from '@/rosa';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import type { IpeHistoryTileData } from '../../interfaces/Tile.interface';

@Injectable({
    providedIn: 'root'
})
export class AdvizeoCoreIpeHistoryProvider {
    private _rosaCoreApiService = inject(RosaCoreApiService);

    getIpeHistoryById$(tileId: string, step: string, isVatIncl: boolean, buildingId: BuildingId): Observable<IpeHistoryTileData> {
        const paramsQuery = `?step=${step}&isVatIncl=${isVatIncl}&buildingId=${buildingId}`;

        return this._rosaCoreApiService.get(`${CoreApiVersionPath.V3}tiles/ipe/${tileId}/history${paramsQuery}`);
    }

    getIpePreviewHistory$(previewConfig: any, step: string): Observable<IpeHistoryTileData> {
        const paramsQuery = `?step=${step}`;
        return this._rosaCoreApiService.post(`${CoreApiVersionPath.V3}tiles/ipe/history/preview${paramsQuery}`, previewConfig);
    }
}
